import {
    fetchDecorationTypes,
    fetchDecorationPortraits,
    fetchDecorations,
    postDecoration
} from "../data/apiClient";

import { getDecorationTypeMappedList } from "./decorationTypeMapper";

export const decorationRepository = {
    getDecorationTypes: async () => {
        const response = await fetchDecorationTypes();
        return getDecorationTypeMappedList(response.data);
    },

    getDecorationPortraits: async () => {
        const response = await fetchDecorationPortraits();
        return response.data;
    },

    getDecorations: async (typeCode, page) => {
        const response = await fetchDecorations(typeCode, page);
        const result = response.data;
        return result
    },

    postDecoration: async (formBody) => {
        try {
            const response = await postDecoration(formBody);
            return { success: response.status === 200 };
        } catch (error) {
            return { success: false, message: 'Something went wrong' };
        }
    }

};